import type { IconProps } from './types';

export const ArrowDown = ({ size, ...props }: IconProps) => (
  <svg fill="none" width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.00004 3.33331V12.6666M8.00004 12.6666L3.33337 7.99998M8.00004 12.6666L12.6667 7.99998"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
